module.exports = __webpack_public_path__ + "img/Peru.6fd8c358.png";